<template>
  <zm-form class="opc-zone-bundle__main-add-content" @submit.prevent>
    <!-- config calling plan row -->
    <config-calling-row
      :min-hosts="minHosts"
      :billing-cycle="form.billingCycle"
      :plan-list="usRegionPlanList" />
    <!-- config billing cycle -->
    <plan-billing-cycle
      v-model:billing-cycle="form.billingCycle"
      :category-list="usRegionPlanList"
      :monthly-disabled-alert-message="monthlyDisabledAlertMessage"
      class="opc-zone-cycle"
      :consider-time-base-coupon-with-base-plan="considerTimeBaseCouponWithBasePlan"
      @updatePbxBasePlanCode="updatePbxBasePlanCode" />
    <!-- config pbx base plan -->
    <config-pbx-base
      v-model="form.basePlanCode"
      :billing-cycle="form.billingCycle" />
  </zm-form>
</template>

<script type="text/jsx" lang="jsx">
import _ from 'lodash';
import { plansof } from '@/utils/chain';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import ConfigCallingRow from '@/plans/ZONE_PRO_PLUS/component/config-calling-row';
import { isEmptyVal } from '@/utils';
import { mapGetters } from 'vuex';
import PlanBillingCycle from '@/plans/ZONE_PRO_PLUS/component/plan-billing-cycle';
import ConfigPbxBase from '@/plans/ZONE_PRO_PLUS/component/pbx-base';

export default {
  mixins: [PbxMixin],
  components: { ConfigCallingRow, PlanBillingCycle, ConfigPbxBase },
  props: {
    minHosts: {
      type: Number,
      default: 1,
    },
    considerTimeBaseCouponWithBasePlan: Boolean,
    monthlyDisabledAlertMessage: String,
  },
  data() {
    return {
      PBX_REGIONS: Object.freeze(PBX_REGIONS),
      form: {
        billingCycle: '',
        basePlanCode: '',
      },
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat']),
    planList() {
      return plansof(this.planMapFlat).type(planTypes.ZONE_PRO_PLUS).get();
    },
    usRegionPlanList() {
      return this.getPlanList(PBX_REGIONS.US_AND_CANADA);
    },
  },
  methods: {
    getPlanList(region) {
      return _.filter(this.planList, (p) => p.region === region);
    },
    updatePbxBasePlanCode(code) {
      this.form.basePlanCode = code;
    },
    initForm() {
      if (this.selectedPbxBasePlan) {
        this.form.basePlanCode = this.selectedPbxBasePlan.plan_code;
      }

      if (!isEmptyVal(this.selectedZoneProPlusCallingPlan)) {
        this.form.billingCycle = this.selectedZoneProPlusCallingPlan.billing_cycle;
      } else if (!this.selectedPbxBasePlan.is_payg) {
        this.form.billingCycle = this.selectedPbxBasePlan.billing_cycle;
      } else {
        this.form.billingCycle = BILLING_CYCLE.ANNUAL;
      }
    },
  },
  created() {
    this.initForm();
  },
};
</script>

<style lang="scss">
</style>
